import React from "react";

import { Field, Form, Formik } from "formik";
import { MdOutlineSend } from "react-icons/md";
import * as Yup from "yup";

import DSButton from "../../../../components/DSButton";
import * as S from "./style";
import { InputWrapper } from "../../../../components/InputWrapper";

export function SendMailForm({
  onSubmit,
  clientMail,
  hasPermissionToSendToUnregistered = false,
  onClose,
  isSubmitting = false,
}) {
  const handleChangeSendToUnregisteredMail = (checked, setFieldValue) => {
    setFieldValue("sendToUnregisteredEmail", checked);
    setFieldValue("customEmail", "");
  };

  return (
    <S.FormWrapper>
      <Formik
        initialValues={{
          email: clientMail ?? "0",
          sendToUnregisteredEmail: false,
          customEmail: "",
        }}
        validationSchema={Yup.object({
          sendToUnregisteredEmail: Yup.boolean(),

          customEmail: Yup.string().when("sendToUnregisteredEmail", {
            is: true,
            then: (schema) =>
              schema
                .required("O email é um campo obrigatório")
                .email("Deve ser um e-mail válido")
                .max(254, "O email deve possuir no máximo 254 caracteres"),
            otherwise: (schema) => schema.notRequired(),
          }),

          email: Yup.string()
            .nullable()
            .when("sendToUnregisteredEmail", {
              is: false,
              then: (schema) =>
                schema
                  .required("O email é um campo obrigatório")
                  .notOneOf(["0"], "O email é um campo obrigatório")
                  .email("Deve ser um e-mail válido"),
              otherwise: (schema) => schema.notRequired(),
            }),
        })}
        onSubmit={onSubmit}
        onReset={onClose}
      >
        {({ setFieldValue, values, validateForm }) => (
          <Form noValidate>
            <Field name="email">
              {({ field, meta }) => (
                <InputWrapper
                  label="Selecione o e-mail"
                  error={meta.error}
                  isRequired={!values.sendToUnregisteredEmail}
                  name={field.name}
                >
                  <S.CustomSelect
                    value={field?.value || "0"}
                    disabled={values.sendToUnregisteredEmail}
                    className={meta.error ? "error-id" : null}
                    onChange={(value) => {
                      setFieldValue("email", value);
                    }}
                    id={field.name}
                  >
                    <S.CustomSelect.Option value="0">
                      Selecione
                    </S.CustomSelect.Option>
                    {clientMail && (
                      <S.CustomSelect.Option value={clientMail}>
                        {clientMail}
                      </S.CustomSelect.Option>
                    )}
                  </S.CustomSelect>
                </InputWrapper>
              )}
            </Field>
            {hasPermissionToSendToUnregistered && (
              <Field name="sendToUnregisteredEmail">
                {({ field }) => (
                  <S.CustomCheckbox
                    checked={field?.value ?? false}
                    onChange={(e) => {
                      handleChangeSendToUnregisteredMail(
                        e.target.checked,
                        setFieldValue
                      );
                    }}
                  >
                    Enviar para outro e-mail
                  </S.CustomCheckbox>
                )}
              </Field>
            )}
            {hasPermissionToSendToUnregistered &&
              values.sendToUnregisteredEmail && (
                <Field name="customEmail">
                  {({ field, meta }) => (
                    <InputWrapper
                      label="Digite o e-mail"
                      error={meta.error}
                      name={field.name}
                      isRequired={values.sendToUnregisteredEmail}
                    >
                      <S.CustomInput
                        type="email"
                        className={meta.error ? "error-id" : null}
                        placeholder="Digite o e-mail que será enviado"
                        {...field}
                        disabled={!values.sendToUnregisteredEmail}
                        onChange={(e) => {
                          field?.onChange(e);
                        }}
                        id={field.name}
                        maxLength={254}
                      />
                    </InputWrapper>
                  )}
                </Field>
              )}

            <div className="item-submit">
              <DSButton
                type="reset"
                buttonText="Cancelar"
                buttonType="secondary"
                isCancelType
                height={30}
                style={{
                  padding: "0.4rem 1.5rem",
                }}
                isDisabled={isSubmitting}
                disabled={isSubmitting}
              />
              <DSButton
                type="submit"
                buttonText="Enviar"
                buttonType="secondary"
                icon={<MdOutlineSend />}
                height={30}
                style={{
                  padding: "0.4rem 1.5rem",
                }}
                isLoading={isSubmitting}
                isDisabled={isSubmitting}
                disabled={isSubmitting}
              />
            </div>
          </Form>
        )}
      </Formik>
    </S.FormWrapper>
  );
}
